.topSection {
    display: flex;
    flex-direction: row;
    margin-top: 35px;
}

.sliderAndTableContainer {
    width: 50%;
}

.sliderContainer {
    display: flex;
    flex-direction: row;
    align-items: center;
}

.sliderErrorContainer {
    display: flex;
    align-items: center;
    margin-left: 20px;
    /* Matches the height of the sliders. */
    height: 30px;
}

.ratingLabelContainer {
    display: flex;
    gap: 5px;
    align-items: center;
}

.maximumValue {
    display: flex;
    align-items: center;
    /* The maximum value row doesn't have a text form field, so we need to hardcode a height to make it the same as the other rows. */
    height: 35px;
    /* Matches the padding in the number inputs that are in the other rows. */
    padding-left: 12px;
}

.maxPointsWithError {
    display: flex;
    align-items: center;
    gap: 8px;
}